import { createActions, createReducer } from 'reduxsauce'

import SituacaoCronologicaService from '../servicos/SituacaoCronologiaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaSituacaoInicio: [],
    buscaSituacaoSucesso: ['situacao'],
    buscaSituacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaSituacao = () => {
    return dispatch => {
        dispatch(Creators.buscaSituacaoInicio())
        let serv = new SituacaoCronologicaService()
        return serv
            .getSituacaoCronologica()
            .then(response => dispatch(Creators.buscaSituacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaSituacaoErro(error)))
    }
}

const buscaSituacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaSituacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaSituacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.situacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_SITUACAO_INICIO]: buscaSituacaoInicio,
    [Types.BUSCA_SITUACAO_ERRO]: buscaSituacaoErro,
    [Types.BUSCA_SITUACAO_SUCESSO]: buscaSituacaoSucesso,
})
